import { Status } from '@/shared/types/Status';

export const PROGRESS: {
  [key in Status]?: number;
} = {
  [Status.created]: 1,
  [Status.determineSpeakersDone]: 42,
  [Status.determineSpeakersFailed]: 100,
  [Status.determineSpeakersStarted]: 27,
  [Status.forbiddenLink]: 100,
  [Status.mergingDone]: 100,
  [Status.mergingStarted]: 95,
  [Status.noAudio]: 100,
  [Status.noWords]: 100,
  [Status.separateBackgroundDone]: 15,
  [Status.separateBackgroundFailed]: 100,
  [Status.separateBackgroundStarted]: 10,
  [Status.transcribeSegmentsDone]: 20,
  [Status.transcribeSegmentsFailed]: 100,
  [Status.transcribeSegmentsStarted]: 16,
  [Status.transcriptEdited]: 100,
  [Status.transcriptionDone]: 42,
  [Status.transcriptionStarted]: 10,
  [Status.translationDone]: 100,
  [Status.translationStarted]: 60,
  [Status.uploaded]: 7,
  [Status.uploading]: 3,
  [Status.voiceEdited]: 100,
  [Status.voiceoverDone]: 93,
  [Status.voiceoverStarted]: 65,
  [Status.voiceSuggestDone]: 55,
  [Status.voiceSuggestFailed]: 55,
  [Status.voiceSuggestStarted]: 45,
  [Status.voiceUpdateDone]: 100,
  [Status.voiceUpdateFailed]: 100,
};
export const SRC_SRT_UPLOAD_PROGRESS: {
  [key in Status]?: number;
} = {
  ...PROGRESS,
  [Status.translationDone]: 100,
  [Status.translationStarted]: 86,
  [Status.voiceSuggestDone]: 85,
  [Status.voiceSuggestFailed]: 85,
};
export const DST_SRT_UPLOAD_PROGRESS: {
  [key in Status]?: number;
} = {
  ...PROGRESS,
  [Status.voiceSuggestDone]: 100,
  [Status.voiceSuggestFailed]: 100,
};
export const AUTOGENERATION_PROGRESS = {
  ...PROGRESS,
  [Status.translationDone]: 80,
  [Status.voiceoverDone]: 93,
  [Status.voiceoverStarted]: 85,
} as const;
